export default {
    navModalVisible:false,
    toolsModalVisible:false,
    modalVisible:false,
    deleteVisible:{
        state:false,
        txtOne:'确认删除该模块？',
        txtTwo:'您已修改页面配置数据，是否需要保存？',
        description:'',
        delIndex:Object.create(null)
    },
    form:{
        name:'',
        title:'',
        url:'',
        img:'',
        img2:'',
    },
    api_root:"",
    uploadkey:"",
    activeName:"1",//dialog弹窗中tab页当前激活项
    isAdd: true,//判断弹窗是否为新增
    list: [],//存放二级容器
    viewport:[],//存放三级容器
    activeIcon:-1,//本地静态底部导航图标索引
    iconList:[
        {url:"static/images/setting/icon/1.png"},
        {url:"static/images/setting/icon/2.png"},
        {url:"static/images/setting/icon/3.png"},
        {url:"static/images/setting/icon/4.png"},
        {url:"static/images/setting/icon/5.png"},
        {url:"static/images/setting/icon/6.png"},
        {url:"static/images/setting/icon/7.png"},
        {url:"static/images/setting/icon/8.png"},
        {url:"static/images/setting/icon/9.png"},
        {url:"static/images/setting/icon/10.png"},
        {url:"static/images/setting/icon/11.png"},
        {url:"static/images/setting/icon/12.png"},
        {url:"static/images/setting/icon/13.png"},
        {url:"static/images/setting/icon/14.png"},
        {url:"static/images/setting/icon/15.png"},
        {url:"static/images/setting/icon/16.png"},
        {url:"static/images/setting/icon/17.png"},
        {url:"static/images/setting/icon/18.png"},
        {url:"static/images/setting/icon/19.png"},
        {url:"static/images/setting/icon/20.png"},
        {url:"static/images/setting/icon/21.png"},
        {url:"static/images/setting/icon/22.png"},
        {url:"static/images/setting/icon/23.png"},
        {url:"static/images/setting/icon/24.png"},
    ],
    activeFooterTab:0,//app预览图底部导航
    activeRightBox:Object.create(null),//当前添加模块
    sysConfig: {//新增子项时，系统默认配置模块集合
        module:'',
        currentPage:1,//分页用
        list:[]
    },
    footerBar:Object.create(null),//存放getData方法最外层对象
    rules1: {
        name:[{required:true,message:'请输入名称'},{ validator: function(rule, value, callback) {
            if(value.length<=5) {
                return callback();
            }else {
                return callback(new Error(rule.message));
            }
        },required: true,message:'名称不可超过5个字' }],
        title:[{required:true,message:'请输入标题'}],
        url:[{required:true,message:'请输入链接'}],
        img:[{required:true,message:'请上传图标'}],
        img2:[{required:true,message:'请上传图标'}]
    },
    rules2: {
        name:[{required:true,message:'请输入名称'},{ validator: function(rule, value, callback) {
            if(value.length<=4) {
                return callback();
            }else {
                return callback(new Error(rule.message));
            }
        },required: true,message:'名称不可超过4个字' }],
        title:[{required:true,message:'请输入标题'}],
        url:[{required:true,message:'请输入链接'}],
        img:[{required:true,message:'请上传图标'}],
        img2:[{required:true,message:'请上传图标'}]
    },
    loading:false,
    // MODULE:['工具栏','顶部导航','个人中心按钮'],
    MODULE:['TOOLBAR','TOP_NAVIGATION','FUNCTION_MENUE'],
    dataChanged:false,//监听列表渲染数据是否变动
}
